import { TextField, IconButton } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    duplicateField,
    getProjectNameOfField,
    isShowDuplicateButton,
    isSystemField,
    onCloseFieldExpandMore,
    removeCurrentGUIAddField,
    getOrgName
} from '@/component/formManagement/handler/FieldListHandler';
import SettingFormDev from '@/component/formManagement/SettingFormDev';
import {
    updateParentFieldList,
    isAddNewField,
    onChangeFieldName,
    isUseFieldInForm,
    isFieldError,
    getErrorByField,
    isEditField,
    isPermissionDeleteField,
    validateAddFieldNameCustom,
    onChangeFieldNameREF,
    isDisplayOptionShareField
} from '../handler/CommonHandler';
import { duplicateField as duplicateFieldInForm } from '@/component/formManagement/handler/FormListHandler';
import ShareField from '../ShareField';
import FieldIdCommon from './FieldIdCommon';
import { useRecoilValue } from 'recoil';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { tr, trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function AddFieldText(props) {
    // Subscribe to translation updates so displayed labels re-render on language change
    useTranslationSubscription();
    // Atom
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const corporationDetail = useRecoilValue(corporationAtom);

    // more action popover
    const [moreActionPopover, setMoreActionPopover] = useState(null);
    const isOpenMoreActionPopover = Boolean(moreActionPopover);

    const indexAddField = Utils.findIndexInArrayById(props.currentAddField.id, props.fieldAddList);

    // const currentFieldData = props.fieldAddList[indexAddField];
    
    const [currentFieldData, setCurrentFielData] = useState(props.fieldAddList[indexAddField]);

    const isUsingProject = Utils.isEmpty(currentFieldData?.usingProjects)
        ? false
        : currentFieldData.usingProjects.includes(props.projectDetail.id);
    const isUsingForm = Utils.isEmpty(currentFieldData?.isUsingForm)
        ? false
        : currentFieldData.isUsingForm;

    const fieldRef = useRef('');

    const argsAll = {
        ...props,
        indexAddField,
        currentFieldData,
        isUsingProject,
        isUsingForm
    };

    useEffect(() => {
        setCurrentFielData(props.fieldAddList[indexAddField]);
    }, [props.fieldAddList[indexAddField]]);

    /** handler enter text input name */
    const onEnterTextInputName = event => {
        let textValue = event.target.value;

        let isValidate = validateAddFieldNameCustom(textValue, argsAll);

        // if event diff enter then return
        if(isValidate && props.isChangeData === false){
            props.setIsChangeData(true);
        }
        if (event.key !== 'Enter' || isValidate) {
            return;
        }

        let newName = {
            jp: {
                A: 'F',
                text: textValue
            }
        };

        // reset fieldType selected
        let fieldTypeSelectedList = [...props.fieldTypeSelectedList];
        fieldTypeSelectedList = Utils.removeItemInArrayById(
            props.currentAddField.id,
            fieldTypeSelectedList
        );
        props.setFieldTypeSelectedList(fieldTypeSelectedList);

        props.fieldAddList[indexAddField].name = newName;
        props.fieldAddList[indexAddField].usingProjects = isUsingProject
            ? [props.projectDetail.id]
            : [];
        props.fieldAddList[indexAddField].isUsingProject = isUsingProject;
        props.fieldAddList[indexAddField].isErrorValidate = false;
        props.fieldAddList[indexAddField].isShowInfo = false;

        // update in field list or dragdrop data
        updateParentFieldList(props, currentFieldData, newName, isUsingProject);
    };

    // update ref
    useEffect(() => {
        if (!Utils.isEmpty(currentFieldData) && !Utils.isEmpty(props.fieldRefList)) {
            props.fieldRefList[currentFieldData.id] = fieldRef;
        }
    });

    const handleOnChangeFieldName = (e, args) => {
        let currentFieldDataClone = {...currentFieldData};
        currentFieldDataClone = onChangeFieldNameREF(e, currentFieldDataClone, args);
        setCurrentFielData(currentFieldDataClone);
    }

    const renderCustomField = () => {
        return (
            <li
                className={
                    isUseFieldInForm(currentFieldData, props.formList, argsAll)
                        ? 'listField-li'
                        : 'listField-li background-color-usingForm'
                }
                id={currentFieldData.id}
                // ref={props.fieldRefList[props.currentUpdateField.id]}
                ref={fieldRef}
                style={{ width: '100%' }}
            >
                <div
                    className={
                        isUseFieldInForm(currentFieldData, props.formList, argsAll)
                            ? 'fieldSetting-info fieldSetting-info--changeForm'
                            : 'fieldSetting-info fieldSetting-info--changeForm background-color-usingForm'
                    }
                >
                    <div className="fieldSetting-thumb">
                        <img src="/assets/image/icon-field05.svg" alt="" />
                    </div>
                    <div className="fieldSetting-cmt">
                        <div className="fieldSetting-name">
                            <div className="formCreate">
                                <TextField
                                    data-cy="add-iframe-field-name"
                                    placeholder={tr('フィールド名')}
                                    onKeyPress={onEnterTextInputName}
                                    // onChange={e => onChangeFieldName(e, argsAll)}
                                    onChange={e => handleOnChangeFieldName(e, argsAll)}
                                    onBlur={e => onChangeFieldName(e, argsAll)}
                                    // onBlur={e => onBlurUpdateField(currentFieldData, argsAll)}
                                    defaultValue={Utils.getTextByLanguage(
                                        Constant.LANGUAGE_TYPE.JP,
                                        currentFieldData.name
                                    )}
                                    className="form-input-outlined"
                                    error={isFieldError('name', currentFieldData)}
                                    helperText={getErrorByField('name', currentFieldData)}
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                />
                                <p className="fieldSetting-text">
                                    {getProjectNameOfField(currentFieldData, props.projectList)}
                                </p>
                                {currentFieldData?.affiliationOrganization !== props.corporationDetail.id && (
                                    <p className="fieldSetting-text  --3">
                                        {getOrgName(props?.allListCorp ,currentFieldData?.affiliationOrganization)}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="fieldSetting-autofill">
                            <div
                                className={
                                    isUseFieldInForm(currentFieldData, props.formList, argsAll)
                                        ? 'fieldSetting-item'
                                        : 'fieldSetting-item background-color-usingForm'
                                }
                            >
                                {!isSystemField(currentFieldData) &&
                                    !isAddNewField(currentFieldData) && (
                                        <>
                                            {isShowDuplicateButton(currentFieldData) && (
                                                <IconButton
                                                    className="itemTools"
                                                    onClick={e => {
                                                        setMoreActionPopover(null);
                                                        if (
                                                            props.parentPanelScreen ===
                                                            Constant.FORM_MANAGEMENT_SCREEN
                                                                .LIST_FIELD
                                                        ) {
                                                            duplicateField(props, currentFieldData);
                                                        } else if (
                                                            [
                                                                'listFieldAddToForm',
                                                                'listFieldInProject'
                                                            ].includes(props.regionDropIdBlock)
                                                        ) {
                                                            duplicateFieldInForm(
                                                                props,
                                                                currentFieldData,
                                                                props.regionDropIdBlock
                                                            );
                                                        }
                                                        if (props.isChangeData === false) props.setIsChangeData(true);
                                                    }}
                                                >
                                                    <img src="/assets/image/icon-copy.svg" alt="" />
                                                </IconButton>
                                            )}

                                            {isPermissionDeleteField(
                                                currentFieldData,
                                                props.formList,
                                                argsAll
                                            )&& (
                                                    <IconButton className="itemTools">
                                                        <img
                                                            src="/assets/image/icon-tabs-delete.svg"
                                                            alt=""
                                                            onClick={e => {
                                                                props.handleClick(e);
                                                                props.setCurrentFieldSelected(
                                                                    props.currentAddField
                                                                );
                                                                props.setIsOpenConfirmDeleteModal(
                                                                    true
                                                                );
                                                                props.handleClose();
                                                            }}
                                                        />
                                                    </IconButton>
                                                )}

                                            {!props.disableBtnShowMore && (
                                                <IconButton
                                                    className="itemTools itemTools-arrow"
                                                    onClick={e =>
                                                        onCloseFieldExpandMore(
                                                            props,
                                                            currentFieldData
                                                        )
                                                    }
                                                >
                                                    <img
                                                        src="/assets/image/icon-arrow-accordion-gray.svg"
                                                        alt=""
                                                    />
                                                </IconButton>
                                            )}
                                        </>
                                    )}

                                {/* add new field */}
                                {!isSystemField(currentFieldData) &&
                                    isAddNewField(currentFieldData) && (
                                        <>
                                            <IconButton
                                                className="itemTools"
                                                onClick={event => {
                                                    setMoreActionPopover(null);
                                                    removeCurrentGUIAddField(props);
                                                }}
                                            >
                                                <img
                                                    src="/assets/image/icon-tabs-delete.svg"
                                                    alt=""
                                                />
                                            </IconButton>

                                            {!props.disableBtnShowMore && (
                                                <IconButton
                                                    className="itemTools itemTools-arrow"
                                                    onClick={e =>
                                                        onCloseFieldExpandMore(
                                                            props,
                                                            currentFieldData
                                                        )
                                                    }
                                                >
                                                    <img
                                                        src="/assets/image/icon-arrow-accordion-gray.svg"
                                                        alt=""
                                                    />
                                                </IconButton>
                                            )}
                                        </>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
                <FieldIdCommon fieldId={props.currentAddField?.id}/>

                {/* Share option */}
                {isDisplayOptionShareField(props?.parentPanelScreen, projectInuseDetail?.id, currentFieldData.affiliationProject, corporationDetail?.rootFlag) && <ShareField {...props} />}

                <div className="addField-wrap">
                    {(props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
                        props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) && (
                        <SettingFormDev {...props} />
                    )}
                </div>
            </li>
        );
    };

    const renderSystemField = () => {
        return (
            <li
                className={
                    isUseFieldInForm(currentFieldData, props.formList, argsAll)
                        ? 'listField-li'
                        : 'listField-li background-color-usingForm'
                }
                id={currentFieldData.id}
                // ref={props.fieldRefList[props.currentUpdateField.id]}
                ref={fieldRef}
            >
                <div className="listWrap-wrap-content">
                    <div className="listWrap-content field-size">
                        <div className="listWrap-icon">
                            <img src="/assets/image/icon-field05.svg" alt="" />
                        </div>
                        <div className="listWrap-name">
                            <span>
                                {trLabel(Utils.getTextByLanguage(
                                    Constant.LANGUAGE_TYPE.JP,
                                    currentFieldData.name
                                ))}
                            </span>
                        </div>

                        <div className="listWrap-field-default">
                            {isSystemField(currentFieldData) ? tr('自動入力') : ''}
                        </div>
                        <div className="listWrap-project-owner">
                            {getProjectNameOfField(currentFieldData, props.projectList)}
                        </div>
                        <div className="listWrap-icon">
                            <span className="listWrap-item"></span>
                            <span
                                className={
                                    currentFieldData.isShowInfo
                                        ? 'listWrap-arrow listWrap-arrow-transform'
                                        : 'listWrap-arrow'
                                }
                            >
                                {!props.disableBtnShowMore && (
                                    <ExpandMoreIcon
                                        onClick={e =>
                                            onCloseFieldExpandMore(props, currentFieldData)
                                        }
                                    />
                                )}
                            </span>
                        </div>
                    </div>
                    <div className="addField-wrap">
                        {(props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
                            props.parentPanelScreen ===
                                Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) && (
                            <SettingFormDev {...props} />
                        )}
                    </div>
                </div>
            </li>
        );
    };

    return (
        <>
            {indexAddField === -1 ? (
                <></>
            ) : (
                <>
                    {(props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
                        props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) &&
                        isSystemField(currentFieldData) &&
                        renderSystemField()}
                    {!isSystemField(currentFieldData) && renderCustomField()}
                </>
            )}
        </>
    );
}
